import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/src/locale/es";
import { ThemeConfig } from "@/config/theme";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: ThemeConfig.colors.primary,
        secondary: ThemeConfig.colors.secondary,
        accent: ThemeConfig.colors.accent,
        error: ThemeConfig.colors.error,
        warning: ThemeConfig.colors.warning,
        info: ThemeConfig.colors.info,
        success: ThemeConfig.colors.success,
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
